import { useCallback, useEffect, useState } from 'react';
import { getPoWorkflowFilters, setPoWorkflowFilters } from './po_workflow_filters.store';

export const usePoWorkflowFilters = (selectedTab) => {
  const [filters, setFilters] = useState(() => ({ ...getPoWorkflowFilters(selectedTab) }));

  useEffect(() => {
    setFilters({ ...getPoWorkflowFilters(selectedTab) });
  }, [selectedTab]);

  useEffect(() => {
    setPoWorkflowFilters(selectedTab, filters);
  }, [selectedTab, filters]);

  const setSearchTerm = useCallback((value) => {
    setFilters((prev) => ({ ...prev, searchTerm: value }));
  }, []);

  const setSelectedDate = useCallback((value) => {
    setFilters((prev) => ({ ...prev, selectedDate: value }));
  }, []);

  const setSelectedCity = useCallback((value) => {
    setFilters((prev) => ({ ...prev, selectedCity: value }));
  }, []);

  const setSelectedVendor = useCallback((value) => {
    setFilters((prev) => ({ ...prev, selectedVendor: value }));
  }, []);

  const setAllInvoicesDateFrom = useCallback((value) => {
    setFilters((prev) => ({ ...prev, allInvoicesDateFrom: value }));
  }, []);

  const setAllInvoicesDateTo = useCallback((value) => {
    setFilters((prev) => ({ ...prev, allInvoicesDateTo: value }));
  }, []);

  const setAllInvoicesStatus = useCallback((value) => {
    setFilters((prev) => ({ ...prev, allInvoicesStatus: value }));
  }, []);

  return {
    searchTerm: filters.searchTerm,
    selectedDate: filters.selectedDate,
    selectedCity: filters.selectedCity,
    selectedVendor: filters.selectedVendor,
    allInvoicesDateFrom: filters.allInvoicesDateFrom,
    allInvoicesDateTo: filters.allInvoicesDateTo,
    allInvoicesStatus: filters.allInvoicesStatus,
    setSearchTerm,
    setSelectedDate,
    setSelectedCity,
    setSelectedVendor,
    setAllInvoicesDateFrom,
    setAllInvoicesDateTo,
    setAllInvoicesStatus,
  };
};
